import React from 'react';
import { Section } from './ui/Section';
export function ProtocolReveal() {
  return <Section alternate data-id="element-209">
      <div className="text-center mb-16" data-id="element-210">
        <h2 className="text-4xl md:text-5xl text-[#c9a04e] mb-6" data-id="element-211">
          Protocolo 3×7
        </h2>
        <p className="text-lg md:text-xl text-[#f5f0e8]/90 max-w-lg mx-auto leading-relaxed" data-id="element-212">
          Tres micro-rituales. Siempre igual. Siempre en el mismo orden.
          Repetidos 7 noches para que tu sistema nervioso entienda:{' '}
          <span className="italic" data-id="element-213">"se acabó el día"</span>.
        </p>
      </div>

      <div className="space-y-12 relative" data-id="element-214">
        {/* Connecting line */}
        <div className="absolute left-[19px] top-4 bottom-4 w-[1px] bg-[#c9a04e]/20 hidden md:block" data-id="element-215"></div>

        {/* Step 1 */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 relative" data-id="element-216">
          <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full border border-[#c9a04e] text-[#c9a04e] font-serif text-xl bg-[#1e2d3d] z-10" data-id="element-217">
            1
          </div>
          <div data-id="element-218">
            <h3 className="text-2xl text-[#f5f0e8] mb-2" data-id="element-219">
              Descarga Guiada{' '}
              <span className="text-[#8a9bb0] text-lg font-sans font-normal ml-2" data-id="element-220">
                (5 min)
              </span>
            </h3>
            <p className="text-[#f5f0e8]/80 text-lg leading-relaxed" data-id="element-221">
              Sacas lo que tu mente repite, con estructura. No escribes un
              diario. Vacías un buffer.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 relative" data-id="element-222">
          <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full border border-[#c9a04e] text-[#c9a04e] font-serif text-xl bg-[#1e2d3d] z-10" data-id="element-223">
            2
          </div>
          <div data-id="element-224">
            <h3 className="text-2xl text-[#f5f0e8] mb-2" data-id="element-225">
              Respiración de Apagado{' '}
              <span className="text-[#8a9bb0] text-lg font-sans font-normal ml-2" data-id="element-226">
                (6 min)
              </span>
            </h3>
            <p className="text-[#f5f0e8]/80 text-lg leading-relaxed" data-id="element-227">
              Un ritmo simple (exhalación más larga) para bajar activación
              física.
            </p>
          </div>
        </div>

        {/* Step 3 */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-8 relative" data-id="element-228">
          <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-full border border-[#c9a04e] text-[#c9a04e] font-serif text-xl bg-[#1e2d3d] z-10" data-id="element-229">
            3
          </div>
          <div data-id="element-230">
            <h3 className="text-2xl text-[#f5f0e8] mb-2" data-id="element-231">
              Cierre de Bucle{' '}
              <span className="text-[#8a9bb0] text-lg font-sans font-normal ml-2" data-id="element-232">
                (2–4 min)
              </span>
            </h3>
            <p className="text-[#f5f0e8]/80 text-lg leading-relaxed" data-id="element-233">
              Cierras el sistema abierto con: lo que aparcas, una acción mínima
              para mañana, un guión corto para dejar de discutir con tu cabeza.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-16 p-8 border border-[#c9a04e]/20 bg-[#1a2332]/50 rounded-sm text-center" data-id="element-234">
        <p className="text-lg md:text-xl text-[#f5f0e8]" data-id="element-235">
          <span className="text-[#c9a04e] font-serif block mb-2 text-2xl" data-id="element-236">
            Resultado realista:
          </span>
          no "dormir perfecto", sino dejar de pelear y recuperar control suave.
        </p>
      </div>
    </Section>;
}